export default "__VITE_ASSET__CwBJkHPp__"